export default {
    values: {
      xs: 0,
      sm: 600,
      md: 1300,
      lg: 1300,
      xl: 1536,
    },
};
